import { useState, useCallback } from 'react';

const CLE_STORAGE = '3f_cfg';

const defaultConfig = {
  url: process.env.REACT_APP_WEBHOOK_URL || '',
  prompt: '',
  nom: process.env.REACT_APP_NOM_ASSISTANT || 'Assistant 3F',
  format: 'base64',
};

function chargerConfig() {
  try {
    const saved = localStorage.getItem(CLE_STORAGE);
    if (saved) return { ...defaultConfig, ...JSON.parse(saved) };
  } catch (e) {}
  return defaultConfig;
}

export function useConfig() {
  const [config, setConfig] = useState(chargerConfig);

  const sauvegarder = useCallback((nouvelleConfig) => {
    const c = { ...config, ...nouvelleConfig };
    try { localStorage.setItem(CLE_STORAGE, JSON.stringify(c)); } catch (e) {}
    setConfig(c);
  }, [config]);

  return { config, sauvegarder };
}
